import * as React from 'react';
import * as ReactDom from 'react-dom';
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { TextField } from "office-ui-fabric-react/lib/TextField";
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { MessageBar, MessageBarType, MessageBarButton, initializeIcons} from 'office-ui-fabric-react';

import { useEffect, useState, useContext } from 'react';
import { MessagesContext } from "../common/context";
import { READER } from '../common/consts';
import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';
import { LOG_LEVEL } from "../common/consts";
import { containerStyle, logStyle } from "./Settings.Styles";
import { validateEmail, validateNumberOfItemsInPages } from "../common/inputValidations";

export  const Settings = ( {accessToken})=>{

    const {state,dispatch} = useContext(MessagesContext);
    const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();

    const [from, setFrom] = useState('[]');
    const [fromValidation, setFromValidation] = useState('');
    const [to, setTo] = useState('[]');
    const [toValidation, setToValidation] = useState('');
    const [subject, setSubject] = useState('[]');
    const [subjectValidation, setSubjectValidation] = useState('');
    const [header, setHeader] = useState(`[]`);
    const [headerValidation, setHeaderValidation] = useState('');
    const [footer, setFooter] = useState(`[]`);
    const [footerValidation, setFooterValidation] = useState('');
    const [numberOfItemsInPage, setNumberOfItemsInPage] = useState(1);
    const [numberOfItemsInPageValidation, setNumbertOfItemsInPageValidation] = useState('');

    const [logLevel, setLogLevel] = useState(LOG_LEVEL.SILENT);

    log.info(` @Settings`);
    log.debug(`@Settings accessToken: ${accessToken}`);
  
useEffect(() => {
    log.info(`useEffect @Settings`);
    setFrom(state.emailFrom);
    setTo(state.emailTo);
    setSubject(state.emailSubject);
    setHeader(state.emailHeader);
    setFooter(state.emailFooter);
    setNumberOfItemsInPage(state.numberOfItemsInPage);
    setLogLevel(state.logLevel);

}, []);
const renderFrom = () => {
    log.info(`renderFrom @ Settings`);
    const _fromValidation =
    fromValidation !== "" ? (
        <MessageBar
          isMultiline={false}
          messageBarType={MessageBarType.error}
          isMultiline={false}
          dismissButtonAriaLabel="Close"
          truncated={true}
          overflowButtonAriaLabel="See more"
          dismissButtonAriaLabel="Close"
        >
          {fromValidation}
        </MessageBar>
      ) : (
        ""
      );

    return (
      <>
        <TextField
          value={from}
          label={"Email From:"}
          readOnly={false}
          multiline
          rows={2}
          resizable={true}
          onChange={(event, newValue) => {
            setFrom(newValue);
          }}
        />
        {_fromValidation}
      </>
    );
  };

    const renderTo = () => {
      log.info(`renderTo @ Settings`);
      const _toValidation =
        toValidation !== "" ? (
          <MessageBar
            isMultiline={false}
            messageBarType={MessageBarType.error}
            isMultiline={false}
            dismissButtonAriaLabel="Close"
            truncated={true}
            overflowButtonAriaLabel="See more"
            dismissButtonAriaLabel="Close"
          >
            {toValidation}
          </MessageBar>
        ) : (
          ""
        );

      return (
        <>
          <TextField
            value={to}
            label={"Email To:"}
            readOnly={false}
            multiline
            rows={2}
            resizable={true}
            onChange={(event, newValue) => {
              setTo(newValue);
            }}
          />
          {_toValidation}
        </>
      );
    };

    const renderSubject = () => {
      log.info(`renderSubject @ Settings`);
      const _subjectValidation =
        subjectValidation !== "" ? (
          <MessageBar
            isMultiline={false}
            messageBarType={MessageBarType.error}
            isMultiline={false}
            dismissButtonAriaLabel="Close"
            truncated={true}
            overflowButtonAriaLabel="See more"
            dismissButtonAriaLabel="Close"
          >
            {subjectValidation}
          </MessageBar>
        ) : (
          ""
        );

      return (
        <>
          <TextField
            value={subject}
            label={"Email Subject:"}
            readOnly={false}
            onChange={(event, newValue) => {
              setSubject(newValue);
            }}
          />
          {_subjectValidation}
        </>
      );
    };

    const renderHeader = () => {
      log.info(`renderHeader @ Settings`);

      const _headerValidation =
        headerValidation !== "" ? (
          <MessageBar
            isMultiline={false}
            messageBarType={MessageBarType.error}
            isMultiline={false}
            dismissButtonAriaLabel="Close"
            truncated={true}
            overflowButtonAriaLabel="See more"
            dismissButtonAriaLabel="Close"
          >
            {headerValidation}
          </MessageBar>
        ) : (
          ""
        );
      return (
        <>
          <TextField
            value={header}
            label={"Email Header:"}
            readOnly={false}
            multiline
            rows={4}
            resizable={true}
            onChange={(event, newValue) => {
              setHeader(newValue);
            }}
          />
          {_headerValidation}
        </>
      );
    };

    const renderFooter = () => {
      log.info(`renderFooter @ Settings`);
      const _footerValidation =
        footerValidation !== "" ? (
          <MessageBar
            isMultiline={false}
            messageBarType={MessageBarType.error}
            isMultiline={false}
            dismissButtonAriaLabel="Close"
            truncated={true}
            overflowButtonAriaLabel="See more"
            dismissButtonAriaLabel="Close"
          >
            {footerValidation}
          </MessageBar>
        ) : (
          ""
        );

      return (
        <>
          <TextField
            value={footer}
            label={"Email Footer:"}
            readOnly={false}
            multiline
            rows={4}
            resizable={true}
            onChange={(event, newValue) => {
              setFooter(newValue);
            }}
          />
          {_footerValidation}
        </>
      );
    };
            

    const  renderTitle = () => {
        log.info(`renderTitle @ Settings`);
        return(
            <Label> Enter default values to email properties</Label>
        )    
    }


    const renderNumberOfItemsInPage = () => {
      log.info(`renderNumberOfItemsInPage @ Settings`);

      const _numberOfItemsInPageValidation =
        numberOfItemsInPageValidation !== "" ? (
          <MessageBar
            isMultiline={false}
            messageBarType={MessageBarType.error}
            isMultiline={false}
            dismissButtonAriaLabel="Close"
            truncated={true}
            overflowButtonAriaLabel="See more"
            dismissButtonAriaLabel="Close"
          >
            {numberOfItemsInPageValidation}
          </MessageBar>
        ) : (
          ""
        );

      return (
        <>
          <TextField
            value={numberOfItemsInPage}
            label={"Number Of Message or Replies in a page:"}
            readOnly={false}
            onChange={(event, newValue) => {
              const _newValue = Number.isInteger(newValue.trim())
                ? newValue.trim()
                : numberOfItemsInPage;
              setNumberOfItemsInPage(newValue);
            }}
          />
          {_numberOfItemsInPageValidation}
        </>
      );
    };


    const handleChangeLogLevel = (event,option)  => {
        log.info(`handleChangeLogLevel @ Settings`);
        setLogLevel(option.key); 
    }

    const renderLogLevel = (event) => {
        log.info(`renderLogLevel @ Settings`);
        const options = [
            { key: LOG_LEVEL.TRACE, text: LOG_LEVEL.TRACE },
            { key: LOG_LEVEL.DEBUG, text: LOG_LEVEL.DEBUG },
            { key: LOG_LEVEL.INFO, text: LOG_LEVEL.INFO },
            { key: LOG_LEVEL.WARN, text: LOG_LEVEL.WARN },
            { key: LOG_LEVEL.ERROR, text: LOG_LEVEL.ERROR },
            { key: LOG_LEVEL.SILENT, text: LOG_LEVEL.SILENT },
          ];

        return (<ChoiceGroup selectedKey={logLevel} options={options} onChange={(event,option)=>handleChangeLogLevel(event,option)} label="Select logging level:" />)
    }

    const validateFormInput = () => {
        log.info(`validateFormInput @ Settings`);
        
        let _validated = true
        
        let _fromValidation = ''
        if (!validateEmail(from)){
            _fromValidation = "Error : You have entered an invalid email address!";
             _validated = false;
        }
        setFromValidation(_fromValidation);

        let _toValidation = ''
        if (!validateEmail(to)){
            _toValidation = "Error : invalid email address!";
            _validated = false;
        }

        setToValidation(_toValidation);

        setSubjectValidation('');

        setHeaderValidation('');

        setFooterValidation('');

        let _numbertOfItemsInPageValidation = ''
        if (!validateNumberOfItemsInPages(numberOfItemsInPage)){
            _numbertOfItemsInPageValidation = "Error : number of items in a page needs to be a number between 10 and 99!";
             _validated = false;
        }
        setNumbertOfItemsInPageValidation(_numbertOfItemsInPageValidation);
        
    return _validated;

    }


    const handleSave  = () => {

        log.info(`handleSave @ Settings`);

        let payload;

        if (validateFormInput()) { 

            payload = { emailTo: to};
                dispatch({ type: "SET_EMAIL_TO", payload: payload })
        
                payload = { emailFrom: from};
                dispatch({ type: "SET_EMAIL_FROM", payload: payload })

                payload = { emailSubject: subject};
                dispatch({ type: "SET_EMAIL_SUBJECT", payload: payload })

                payload = { emailHeader: header};
                dispatch({ type: "SET_EMAIL_HEADER", payload: payload })
                
                payload = { emailFooter: footer};
                dispatch({ type: "SET_EMAIL_FOOTER", payload: payload })

                payload = { numberOfItemsInPage: numberOfItemsInPage};
                dispatch({ type: "SET_NUMER_OF_ITEMS_IN_PAGE", payload: payload })

                payload = { logLevel: logLevel};
                dispatch({ type: "SET_LOG_LEVEL", payload: payload })

                log.setLevel(logLevel);

            }

    return    
    }

    const  renderSave = () => {
        log.info(`renderSave @ Settings`);
        return(
                <PrimaryButton  onClick={handleSave}>Save</PrimaryButton>
    )    
}

    return (
            <>
            <br/>
            {renderTitle()}
            <br/>
            {renderTo()}
            <br/>
            {renderSubject()}
            <br/>
            {renderHeader()}
            <br/>
            {renderFooter()}
            <br/>
            {renderNumberOfItemsInPage()}
            <br/>
            {renderLogLevel()}
            <br/>
            {renderSave()}
            <br/>
        </>
    )
}


